import { Button, Steps } from "antd";
import styled from "styled-components";
const { Step } = Steps;

const steps = [
  {
    title: "Selecteer model & reparatie",
    content: "Select-content",
  },
  {
    title: "Afspraak",
    content: "First-content",
  },
  {
    title: "Jouw gegevens",
    content: "Second-content",
  }
];

const Wrapper = styled.div`
  .ant-steps {
    display: flex !important;
  }

  .anticon.anticon-check.ant-steps-finish-icon {
    vertical-align: middle;
  }
  .stepMobile.ant-steps-horizontal.ant-steps-label-horizontal
    .ant-steps-item-content
    .ant-steps-item-title::after {
    content: "" !important;
    display: block !important;
    left: 0 !important;
  }
  .ant-steps-item-active > .ant-steps-item-container > .ant-steps-item-icon {
    background-color: var(--primary-main-color) !important;
    color:#fff !important; 
    border: 1px solid var(--primary-main-color);
  }
  .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-icon {
    color:var(--primary-main-color) !important; 
    border: 1px solid var(--primary-main-color);
    @media (max-width: 420px) {
      background-color: var(--primary-main-color) !important;
    }
  }
  .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-icon > .ant-steps-icon{
    color:var(--primary-main-color) !important; 
    @media (max-width: 420px) {
      color: #fff !important;
    }
  }
  .ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-icon {
    @media (max-width: 420px) {
      border: 1px solid #909090;
      border-radius: 16px;
    }
  }
  .ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-icon > .ant-steps-icon{
    @media (max-width: 420px) {
      color: #909090 !important;
      font-weight: 700;
    }
  }

  .ant-steps-item-container::selection {
    background-color: var(--primary-main-color) !important;
    color:var(--primary-main-color) !important; 

  }
  .ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after  {
    background-color: var(--primary-main-color) !important;
    color:var(--primary-main-color) !important; 

  }
  .ant-steps-item-active > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after  {
    background-color: var(--primary-main-color) !important;
    color:var(--primary-main-color) !important; 

  }
  .ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after  {
    background-color: #E0E0E0 !important;
    @media (max-width: 420px) {
      background-color: #909090 !important;
    }
    color:#909090 !important; 

  }
  .ant-steps-item-title::selection  {
    background-color: var(--primary-main-color) !important;

  }
`;

const StepsAppointment = ({ current = 0 }) => {
  return (
    <Wrapper>
      <div className="none md:block">
        <Steps responsive={false} current={current}>
          {steps.map((item) => (
            <Step key={item.title} title={item.title} />
          ))}
        </Steps>
      </div>
      <div className="md:none">
        <Steps
          className="stepMobile"
          direction="horizontal"
          responsive={false}
          current={current}
        >
          {steps.map((item) => (
            <Step key={item.title} />
          ))}
        </Steps>
      </div>
    </Wrapper>
  );
};

export default StepsAppointment;
